export enum DateKeyEnum {
  accreditation_date = 'accreditation_date',
  created = 'created',
}
